// utils
import handleDownloadButtonsDownloading from "./download-buttons";
import handleDownloadSettingsWritingToWindow from "./download-settings";
import handleBannerButtonDownloading from "./banner-button";

(() => {
  document.addEventListener("DOMContentLoaded", async () => {
    // установка в window.portal настроек скачивания
    handleDownloadSettingsWritingToWindow();

    // кнопки скачивания
    handleDownloadButtonsDownloading();

    // баннер-кнопки
    handleBannerButtonDownloading();
  });
})();